import styled, { keyframes } from 'styled-components';

const rotateAnimation = keyframes`
0% {
  filter: blur(10);
}
100% {
  transform : rotate(100deg)
}
`;

export const Container = styled.div`
  display: flex;

  transition: opacity 0.2s;
  font-weight: bold;
 
   
  justify-content: center;
width: auto ;
  &:hover {
    opacity: 0.9;
  }

  > div {
    padding: 5px;
    display: flex;
    width: 70px;
    height: 70px;
    border-radius: 0px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    background: #fff;
    margin: 5px;
    flex-direction: column;

    > h3 {
      color: #162743;
      font-size: 28px;
    }

    > p {
      color: #162743;
      font-size: 12px;
    }

    @media (max-width: 750px) {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;

    > h3 {
      color: #162743;
      font-size: 22px;
    }

    > p {
      color: #162743;
      font-size: 10px;
    }
  }
  }



 

  > p {
    font-size: 32px;
    margin-top: 10px;
    svg {
      animation: ${rotateAnimation} 1s infinite;
    }
  }
`;
